import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loader-container flex-center" }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = {
  class: "pre-meeting-container",
  style: {"width":"80%","margin":"auto","display":"flex","flex-direction":"column","justify-content":"center"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, "This meetings and/or its payment has been confirmed, theres no need to retry the payment", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "page flex-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, "You aren't the payer for this meeting")
], -1 /* HOISTED */)
const _hoisted_6 = {
  key: 0,
  class: "page flex-center"
}
const _hoisted_7 = {
  key: 0,
  class: "page flex-center"
}
const _hoisted_8 = {
  key: 0,
  class: "page flex-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Meeting Payment Details successfully updated", -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "page flex-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Retry Failed", -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "page flex-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Retry PROCESSING", -1 /* HOISTED */)
const _hoisted_14 = { class: "page" }
const _hoisted_15 = {
  class: "pre-meeting-container",
  style: {"width":"80%","margin":"auto","display":"flex","flex-direction":"column","justify-content":"center"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, "We weren't able to find the meeting associated with this request, try again later", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["retry-payment-container", {'no-scroll': $setup.noScroll}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode($setup["Loader"])
        ])
      ], 2 /* CLASS */))
    : ($setup.authorizedMeeting && $setup.meeting)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["retry-payment-container", {'no-scroll': $setup.noScroll}])
        }, [
          _createVNode(_Transition, {
            onBeforeEnter: _cache[2] || (_cache[2] = ($event: any) => ($setup.noScroll = true)),
            onAfterLeave: _cache[3] || (_cache[3] = ($event: any) => ($setup.noScroll = false)),
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  ($setup.isLoggedIn)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.routeTo('')))
                      }, "Back to Home"))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.routeTo('auth')))
                      }, "Go to Login"))
                ])
              ])
            ]),
            _: 1 /* STABLE */
          })
        ], 2 /* CLASS */))
      : ($setup.wrongUser)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["retry-payment-container", {'no-scroll': $setup.noScroll}])
          }, [
            _createVNode(_Transition, {
              onBeforeEnter: _cache[4] || (_cache[4] = ($event: any) => ($setup.noScroll = true)),
              onAfterLeave: _cache[5] || (_cache[5] = ($event: any) => ($setup.noScroll = false)),
              appear: ""
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1 /* STABLE */
            })
          ], 2 /* CLASS */))
        : ($setup.meeting)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["retry-payment-container", {'no-scroll': $setup.noScroll}])
            }, [
              _createVNode(_Transition, {
                onBeforeEnter: _cache[7] || (_cache[7] = ($event: any) => ($setup.noScroll = true)),
                onAfterLeave: _cache[8] || (_cache[8] = ($event: any) => ($setup.noScroll = false)),
                appear: ""
              }, {
                default: _withCtx(() => [
                  ($setup.stage === $setup.RetryStage.LOGIN)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", { class: "login-actions" }, [
                          _createElementVNode("button", {
                            class: "primary login",
                            onClick: $setup.miniLogin
                          }, "Login"),
                          _createElementVNode("button", {
                            class: "outline signup",
                            onClick: $setup.miniSignup
                          }, "Signup")
                        ]),
                        _createVNode(_Transition, { name: "bring-up" }, {
                          default: _withCtx(() => [
                            ($setup.authOpen)
                              ? (_openBlock(), _createBlock($setup["MiniAuth"], {
                                  key: 0,
                                  isLogin: $setup.showLogin,
                                  onClose: _cache[6] || (_cache[6] = ($event: any) => {$setup.authOpen = false; $setup.showLogin = false; $setup.updateUserDetails()})
                                }, null, 8 /* PROPS */, ["isLogin"]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_Transition, {
                onBeforeEnter: _cache[10] || (_cache[10] = ($event: any) => ($setup.noScroll = true)),
                onAfterLeave: _cache[11] || (_cache[11] = ($event: any) => ($setup.noScroll = false)),
                appear: ""
              }, {
                default: _withCtx(() => [
                  ($setup.stage === $setup.RetryStage.PAYMENTINFO)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode($setup["PaymentReconfirm"], {
                          transaction: $setup.transaction,
                          "onUpdate:transaction": _cache[9] || (_cache[9] = ($event: any) => (($setup.transaction) = $event)),
                          meeting: $setup.meeting,
                          user: $setup.user!,
                          recipient: $setup.recipient!,
                          isLoggedIn: $setup.isLoggedIn,
                          onProgress: $setup.retryPayment
                        }, null, 8 /* PROPS */, ["transaction", "meeting", "user", "recipient", "isLoggedIn"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_Transition, {
                onBeforeEnter: _cache[14] || (_cache[14] = ($event: any) => ($setup.noScroll = true)),
                onAfterLeave: _cache[15] || (_cache[15] = ($event: any) => ($setup.noScroll = false)),
                appear: ""
              }, {
                default: _withCtx(() => [
                  ($setup.stage === $setup.RetryStage.SUCCESS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        ($setup.pastMeeting)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "primary",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.routeTo(`check-in/${_ctx.$route.params.meetingLink}`)))
                            }, "Confirm Meeting"))
                          : ($setup.isLoggedIn)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "primary",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.routeTo('')))
                              }, "Back to Home"))
                            : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_Transition, {
                onBeforeEnter: _cache[17] || (_cache[17] = ($event: any) => ($setup.noScroll = true)),
                onAfterLeave: _cache[18] || (_cache[18] = ($event: any) => ($setup.noScroll = false)),
                appear: ""
              }, {
                default: _withCtx(() => [
                  ($setup.stage === $setup.RetryStage.FAILED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("button", {
                          class: "primary try-again",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.stage = $setup.RetryStage.PAYMENTINFO))
                        }, "Try Again")
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_Transition, {
                onBeforeEnter: _cache[20] || (_cache[20] = ($event: any) => ($setup.noScroll = true)),
                onAfterLeave: _cache[21] || (_cache[21] = ($event: any) => ($setup.noScroll = false)),
                appear: ""
              }, {
                default: _withCtx(() => [
                  ($setup.stage === $setup.RetryStage.PROCESSING)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        ($setup.isLoggedIn)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "primary",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.routeTo('')))
                            }, "Back to Home"))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ], 2 /* CLASS */))
          : (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass(["retry-payment-container", {'no-scroll': $setup.noScroll}])
            }, [
              _createVNode(_Transition, {
                onBeforeEnter: _cache[24] || (_cache[24] = ($event: any) => ($setup.noScroll = true)),
                onAfterLeave: _cache[25] || (_cache[25] = ($event: any) => ($setup.noScroll = false)),
                appear: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      ($setup.isLoggedIn)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "primary",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.routeTo('')))
                          }, "Back to Home"))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "primary",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.routeTo('auth')))
                          }, "Go to Login"))
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ], 2 /* CLASS */))
}